// test2693
(2693 && 0);
